import styled from 'styled-components';

export const PageWrapper = styled.div`
  overflow: hidden;
`;
